import { Text, View } from '@react-pdf/renderer'
import { pdfDefaultFontSize } from '../../common/Common'

type ContactValue = {
  firstName?: string
  lastName?: string
  email?: string
}

/**
 * Props for the FormContactPickerPdf component
 * @interface FormContactPickerPdfProps
 */
export interface FormContactPickerPdfProps {
  value?: ContactValue
  helpText?: string | undefined
  tooltip?: string | undefined
}

/**
 * Component that renders a contact picker in PDF format
 * @component
 * @category Form Components
 * @subcategory PDF Renderers
 * @function FormContactPickerPdf
 * @param {Object | string | undefined} props.value - The value to populate the form fields with (optional).
 * @param {string} [props.helpText] - Optional help text that explains how to fill the field.
 * @param {string} [props.tooltip] - Optional tooltip text.
 * @returns {React.ReactElement} A View component containing the data of the contact.
 */
export const FormContactPickerPdf: React.FC<FormContactPickerPdfProps> = ({
  value,
  helpText,
  tooltip,
  ...props
}: FormContactPickerPdfProps): React.ReactElement => {
  const fullName = value ? value.firstName + ' ' + value.lastName : ''

  return (
    <View>
      <Text 
        style={{ 
          fontSize: pdfDefaultFontSize, 
          fontWeight: 'bold', 
          fontFamily: 'Open Sans' 
        }}
      >
        {fullName}
      </Text>
      <Text 
        style={{ 
          fontSize: pdfDefaultFontSize, 
          fontFamily: 'Open Sans' 
        }}
      >
        {value?.email || ''}
      </Text>
    </View>
  )
}
